export default __webpack_public_path__ + "static/media/Neck.91715f70.svg";